import { generateSpecialHeaders } from 'shared/utils/generateSpecialHeaders';
import { requestService } from 'shared/utils/services/requestService';

interface IFetcherParams {
  url: string;
  key: string;
}

export const fetcher = ({ url, key }: IFetcherParams) =>
  requestService({ url, method: 'GET', headers: generateSpecialHeaders(key) });
